var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSnsLoginNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 26C52 11.64 40.36 0 26 0S0 11.64 0 26s11.64 26 26 26 26-11.64 26-26z",
    fill: "#03C75A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.38 26.669 22.348 16.59h-5.832v18.82h6.104V25.33l7.032 10.079h5.832V16.59H29.38V26.67z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSnsLoginNaver);
export default __webpack_public_path__ + "static/media/btn_sns_login_Naver.0d301160a3c90ca35d288784ff578149.svg";
export { ForwardRef as ReactComponent };